import React from 'react'
import SelectCard from 'src/uiParts/SelectCard'
import TabPanel from 'src/uiParts/TabPanel'
import { State, PartialAction, Position } from 'src/types'
import { SelectCardWithImage } from 'src/uiParts/SelectCardWithImage'
import { useDispatcher, useGorillaSeriesDispatcher } from 'src/features/brands/gorilla/hooks/dispatchGenerator'
import {
  sizeObjs,
  webPartsObjs,
  backLaceObjs,
  seriesObjs,
  DOMINANT_ARM_BUTTON_OPTION,
  SIZE_BUTTON_OPTION,
  BACK_LACE_BUTTON_OPTION,
  WEB_PARTS_BUTTON_OPTION,
  FINGER_GUARD_TYPE_BUTTON_OPTION
} from 'src/features/brands/gorilla/constants/base'
import { webPartsPositionFilter } from 'src/features/brands/hooks/baseSetting'
import {
  baseCautionGenerator,
  baseDescriptionGenerator,
  dominantArmObjectSwitcher,
  fingerGuardTypeObjectSwitcher,
  gorillaFlagGenerator
} from 'src/features/brands/gorilla/hooks/baseSetting'
import { positionChecker } from 'src/util/useModelDesign'

type Props = {
  state: State
  selectedIndex: number
  position: Position
  dispatch: React.Dispatch<PartialAction>
}

const BaseSetter: React.FC<Props> = ({ state, selectedIndex, position, dispatch }) => {
  const { isMitt } = positionChecker(position)
  const { baseModel, series, dominantArm, size, fingerGuardType, webParts, backLace } = state
  const handle = {
    series: useGorillaSeriesDispatcher(baseModel.productNumber, dispatch),
    dominantArm: useDispatcher('dominantArm', dispatch),
    size: useDispatcher('size', dispatch),
    fingerGuardType: useDispatcher('fingerGuardType', dispatch),
    webParts: useDispatcher('webParts', dispatch),
    backLace: useDispatcher('backLace', dispatch)
  }
  const {
    isSelectedSeries,
    isLeftThrow,
    isSelectableSeries,
    isDefaultSize,
    isSelectableDominantArm,
    isSelectableSize,
    isSelectableOthers,
    isBKNModel
  } = gorillaFlagGenerator(state, position)
  return (
    <TabPanel selectedIndex={selectedIndex} index={0}>
      <SelectCard
        summary={'シリーズ'}
        selectedLabel={series?.label}
        objects={seriesObjs}
        isError={state.series?.value === 'unselected'}
        handleChange={handle.series}
        isDisplay={isSelectableSeries}
        defaultExpanded={!isSelectableSeries}
      />
      <SelectCard
        summary={'利き腕'}
        selectedLabel={dominantArm.label}
        objects={dominantArmObjectSwitcher(position)}
        isError={dominantArm?.value === 'unselected'}
        handleChange={handle.dominantArm}
        description={baseDescriptionGenerator(isLeftThrow, 'dominantArm')}
        isDisplay={isSelectableDominantArm}
        className={DOMINANT_ARM_BUTTON_OPTION}
      />
      <SelectCard
        summary={'サイズ'}
        selectedLabel={size.label}
        objects={sizeObjs}
        isError={state.size?.value === 'unselected'}
        handleChange={handle.size}
        caution={baseCautionGenerator(!isDefaultSize, 'size')}
        isDisplay={isSelectableSize}
        className={SIZE_BUTTON_OPTION}
      />
      <SelectCardWithImage
        summary={'指カバー'}
        selectedLabel={fingerGuardType?.label}
        objects={fingerGuardTypeObjectSwitcher(position, state.baseModel.productNumber)}
        handleChange={handle.fingerGuardType}
        isDisplay={isSelectableOthers}
        isError={state.fingerGuardType?.value === 'unselected'}
        imageHeight={80}
        imageWidth={140}
        isShowLabel
        description={isBKNModel && '※BKNモデルでは「指カバー(SKR,BKN用)」が付きます。'}
        className={FINGER_GUARD_TYPE_BUTTON_OPTION}
      />
      <SelectCardWithImage
        summary={'ウェブ'}
        selectedLabel={webParts?.label}
        objects={webPartsPositionFilter(webPartsObjs, position)}
        handleChange={handle.webParts}
        isDisplay={isSelectableOthers && !isMitt}
        isError={state.webParts?.value === 'unselected'}
        caution={isBKNModel ? '※BKNモデルでは[W23ウェブ]がメーカー推奨です。' : ''}
        className={WEB_PARTS_BUTTON_OPTION}
      />
      <SelectCardWithImage
        summary={'背面紐通し'}
        selectedLabel={backLace?.label}
        objects={backLaceObjs}
        handleChange={handle.backLace}
        isDisplay={isSelectedSeries && !isMitt}
        isError={state.backLace?.value === 'unselected'}
        isShowLabel
        imageWidth={160}
        imageHeight={90}
        className={BACK_LACE_BUTTON_OPTION}
      />
    </TabPanel>
  )
}
export default BaseSetter
